// extracted by mini-css-extract-plugin
export var copyable = "_e-1";
export var explainable = "_e-0";
export var negative = "_e-2";
export var positive = "_e-3";